import axiosHttpRequest from "../axios"



async function searchDamageWagonlistService(endpoint, queryparams, configheaders) {
    const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(endpoint, queryparams, configheaders);

    let serviceData = serviceResponse.data;
    let listViewData = [];
    // let listViewDataObj = {};
    let listViewInfo = {};
    if (serviceData.issuccess && serviceData.Records) {
        listViewData = serviceData.Records;
    }
    listViewInfo.records = listViewData;
    listViewInfo.paginationInfo = serviceData.paginationinfo;
    return listViewInfo;
}

async function saveDamageWagonService(endpoint, postdata, configheaders) {
    const serviceResponse = await axiosHttpRequest.execPostRequest(endpoint, postdata, configheaders);
    return serviceResponse;
}

async function searchDashboardlistService(endpoint, queryparams, configheaders) {
    const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(endpoint, queryparams, configheaders);

    let serviceData = serviceResponse.data;
      
    let listViewData = [];
    // let listViewDataObj = {};
    let listViewInfo = {};
    if (serviceData) {
        listViewData = serviceData;
    }
    listViewInfo = listViewData;
      
    listViewInfo.paginationInfo = serviceData.paginationinfo;
    return listViewInfo;
}


export default {
    searchDamageWagonlistService,
    saveDamageWagonService,
    searchDashboardlistService

};



